import { isYoungerThan18 } from 'shared/util/datetime-fns';

export const invalidNameField = (name: string, fieldName?: string) => {
    if (name.trim().length < 1) {
        return `${fieldName} må fylles ut.`;
    }
    if (name.trim().length > 50) {
        return 'Du kan benytte maksimalt 50 tegn.';
    }
    return null;
};

export const invalidNumber = (number: string, fieldName) => {
    if (number == null) {
        return `${fieldName}  fylles ut.`;
    }
    return null;
};

export const invalidMessageField = (message: string) => {
    if (message.trim().length < 1) {
        return 'Melding må fylles ut.';
    }
    if (message.trim().length > 1000) {
        return 'Du kan benytte maksimalt 1000 tegn.';
    }
    return null;
};

export const invalidEmail = (email: string) => {
    if (email.trim().length < 1) {
        return 'Email må fylles ut.';
    }
    if (!email.includes('@')) {
        return 'Gyldig email adresse må fylles ut.';
    }
    if (email.trim().length < 6) {
        return 'Gyldig email adresse må fylles ut.';
    }
    if (email.trim().length > 40) {
        return 'Du kan benytte maksimalt 40 tegn.';
    }
    return null;
};

export const invalidBirthDate = (birthDay: string, birthMonth: string, birthYear: string) => {
    const dateOfBirth = dateOrNull({ day: birthDay, month: birthMonth, year: birthYear });
    return !dateOfBirth;
};

export const tooYoung = (birthDay, birthMonth, birthYear) => {
    const dateOfBirthFormatted = dateOrNull({ day: birthDay, month: birthMonth, year: birthYear });
    return dateOfBirthFormatted ? isYoungerThan18(dateOfBirthFormatted) : false;
};

export const invalidPhone = (landcode: string, phone: string) => {
    if (landcode === '+47' && phone.trim().length !== 8) {
        return 'Norske telefonnummer må være 8 siffer.';
    }
    if (phone.trim().length < 5) {
        return 'Mobiltelefon må fylles ut.';
    }
    if (phone.trim().length > 17) {
        return 'Mobiltelefon er for langt.';
    }
    return null;
};

export const isValidDate = (date: Date) => date instanceof Date && !Number.isNaN(date.getTime());

export const dateOrNull = ({
    day,
    month,
    year,
}: {
    day: string | undefined;
    month: string | undefined;
    year: string | undefined;
}): Date | null => {
    if (!day || !month || !year) {
        return null;
    }

    const dayNum = Number(day);
    const monthNum = Number(month);
    const yearNum = Number(year);
    const date = new Date(yearNum, monthNum, dayNum);

    if (!isValidDate(date)) {
        return null;
    }

    return date;
};
